export default {
    deviceTypes: {
        1: 'pc',
        2: 'h5',
        3: 'android',
        4: 'ios',
        5: 'wechat',
    },
   
    user: {
        checkStatus: [{
            status: '0',
            desc: '未认证'
        }, {
            status: '1',
            desc: '未审核'
        }, {
            status: '-1',
            desc: '审核未通过'
        }, {
            status: '2',
            desc: '已认证'
        }, ],
        role: {
            0: '空',
            1: '甲方',
            2: '乙方',
        },
        customerLevel: {
            0: 'KA',
            1: 'A',
            2: 'B',
            3: 'C',
            4: 'D',
            5: 'E',
        },
        applyStatus: {
            0: '未处理',
            1: '已处理',
            2: '驳回',
        },
        banStatus: {
            0: '正常',
            1: '封禁',
            2: '警告'
        },
        type: {
            1: '个人',
            2: '企业'
        },
        violationType: {
            1: '订单工作较差',
            2: '人才被举报',
            3: '人才被封号'
        }
    },
    payChannel: {
        1: '云账户',
        2: '椰云',
    },
    job: {
        status: {
            0: '关闭',
            1: '开启',
        },
        chargingWay: {
            0: '按时计费',
            1: '固定价格',
        },
        quoteStatus: {
            1: '已投递',
            2: '已撤回',
            3: '合同待确认',
            4: '甲方已撤回合同',
            5: '拒绝合同',
            6: '已雇佣',
        },
        quoteIntention: {
            0: '无',
            1: '已入围',
            2: '已淘汰',
        },
    },
    order: {
        contractType: {
            1: '时薪制',
            2: '项目制',
        },
        contractStatus: {
            1: '未签约',
            2: '已签约',
            3: '已撤回',
            4: '已拒绝',
        },
        workStatus: {
            1: '未开始',
            2: '进行中',
            3: '已停止',
            4: '已完成',
            5: '已关闭',
            6: '退款中',
        },
        sourceType: {
            1: '职位',
            2: '服务'
        },
    },
    finance: {
        settlementStatus: {
            1: '乙方已提交',
            2: '已驳回',
            3: '甲方已确认',
            4: '预发起',
            5: '发起',
            6: '成功',
            7: '异常',
        },
        topupStatus: {
            1: '待确认',
            2: '已确认',
            3: '已驳回',
        },
        // 账单类型
        transactionType: {
            1: '入账',
            2: '提现',
            3: '付款',
            4: '退款'
        },
        status: {
            1: '待处理',
            2: '已确认',
            3: '已驳回',
            4: '处理中',
            5: '支付失败',
        },
        partBstatus: {
            4: '待转账',
            // 6: '可转账',
            2: '已到账',
            5: '转账失败',
            7: '处理中',
        },
        rechargeType: {
            1: '银行转账',
            2: '微信支付',
            3: '支付宝支付',
        },
        // 充值类型
        rechargeTarget: {
            1: '充值到账户',
            2: '充值到订单',
            3: '云豆购买',
            4: '优惠套券购买',
            5: '充值到任务',
            6: '道具购买',
        },
    },
    invoice: {
        type: {
            1: '增值税普通发票',
            2: '增值税专用发票'
        },
        status: {
            1: '审核中',
            2: '已开票',
            3: '已驳回',
        },
        billSubject: {
            0: '用工无忧',
            1: '爱赛',
            2: '东绩'
        }
    },
    match: {
        status: {
            '-1': '无',
            '0': '不合适',
            '1': '合适',
        },
        reason: {
            1: '工作经验不足/不匹配',
            2: '无类似项目经验',
            3: '接单时间不匹配',
            4: '沟通意向度差',
            5: '无法联系到乙方',
            6: '其他',
        },
        type: {
            5: '自动匹配',
            8: '人工匹配',
        },
        pushRule:{
            10: '手续费配置匹配',
            9: '持续匹配推送',
            8: '运营主动推送',
            7: '审核通过推送',
            6: '新用户注册推送',
            5: '精准匹配'
        }
    },
    coupon: {
        activityType: {
            1: '固定发放', // 需用户领取
            2: '灵活发放', // 自动发入账户
        },
        type: {
            1: '满减券',
        },
        status: {
            1: '有效',
            2: '已使用',
            3: '已过期',
        },
        forPeople: {
            1: '全部客户可领',
            2: '全部供应商可领',
            3: '限未发职位客户领取',
            4: '限未成交供应商领取',
            5: '指定用户可领',
            6: '购买'
        },

        forPeopleStatus:{
            6:'购买',         
        },
        useCondition: {
            0: '全部订单结算使用',
            1: '限时薪制订单结算使用',
            2: '限项目制订单结算使用',
            3: '限试用订单使用'
        }
    },
    client: {
        scale: { // 企业规模
            littleEnterprise: '小型企业',
            mediumEnterprise: '中型企业',
            tinyEnterprise: '微型企业',
            notEnterprise: '个人',
        },
        businessStable: { // 业务稳定性
            yes: '具备稳定业务',
            no: '不具备稳定业务',
        },
        cooperativePurpose: { // 合作意向度
            high: '高',
            middle: '中',
            low: '低',
        },
        dockingRole: { // 对接人角色
            empolyer: '使用者',
            decsion: '决策者',
            operator: '操作者',
        },
        perTradingVolume: { // 成交金额预期
            doNotGo: '不走平台',
            tenDown: '10K/月以下',
            tenToThirty: '10-30K/月',
            thirtyUp: '30K/月以上',
        },
        demandImportant: { // 需求重要性
            haveImportance: '有重要需求',
            haveNotImportance: '有非重要需求',
            notExist: '无需求',
        },
        demandEmergencyDegree: { // 需求紧急程度
            threeWithin: '3日内',
            sevenWithin: '7日内',
            thiryWithin: '30日内',
            thiryAbove: '30日以上',
        },
        bargainDifficultyDegree: { // 成交难易程度
            difficult: '难',
            medium: '中',
            simplea: '易',
        },
        orderMoney: { // 订单金额
            amountHigh: '高',
            amountMiddle: '中',
            amountLow: '低',
        },
        followStatus: {
            0: '待跟进',
            1: '待沟通',
            2: '已搁置',
            3: '已转化',
            4: '待匹配',
            5: '待签约',
            6: '待充值',
        },
        type: {
            1: '意向客户',
            2: '转化客户',
            3: '活跃客户',
            4: '成熟客户',
        },
    },
    appeal: {
        type: {
            1: '需求内容沟通不清晰的问题',
            2: '超出约定的工作时限的问题',
            3: '交易过程中对方配合的问题',
            4: '最终交付和预期不符的问题',
            5: '其他问题',
        },
        result: {
            1: '终止合同',
            2: '按原合同完成交付',
            3: '支付已工作的部分佣金',
        },
        status: {
            1: '待确认',
            2: '已驳回',
            3: '已结单', // 撤回(未处理)
            4: '处理中',
            5: '已结单', //撤销(处理中)
            6: '已结单',
        },
        agreeStatus: {
            1: '-', // 未确认
            2: '认可申诉',
            3: '不认可申诉',
        },
    },
    interview: {
        status: {
            1: '待面试',
            2: '已面试',
            3: '取消面试',
        }
    },
    service: {
        showStatus: {
            0: '未审核',
            1: '审核通过',
            2: '审核不通过',
        },
        showStatusList: {
            0: '待审核',
            1: '已通过',
            2: '未通过',
        },
        serviceStatus: {
            1: '上架中',
            2: '已下架',
        },
        operatorType:{
            1:'系统',
            2:'人工',
            3:'用户'
        }
    },
    roles: {
        1: '甲方',
        2: '乙方',
        3: '全部'
    },
    ent: {
        size: {
            1: '少于15人',
            2: '15-50人',
            3: '50-150人',
            4: '150-500人',
            5: '500-2000人',
            6: '2000人以上',
        }
    },
    prop:{
        status:{
            1: '使用中',
            2: '未启用',
            3: '已过期',
            4: '使用完',
            5: '退款中',
            6: '已退款',
        },
        types:{
            1: '沟通卡',
            2: '投递卡',
        },
        getTypes:{
            1: '用户购买',
            2: '运营发放',
            3: '系统发放',
            4: '云豆兑换', 
            5: '等级权益',
            6: '用户领取',
        },
        sourcesRole:{
            0:'系统',
            1:'用户',
            2:'运营人员'
        }

    },
    ad:{
        role:{
            1:'雇主',
            2:'人才'
        },
        targetDevices:{
            1:'PC端',
            2:'H5端',
            3:'Android',
            4:'Ios',
            5:'Wechat'
        },
        pageType:{
            1: "游客落地页",
            2: "首页",
            3: "人才广场",
            4: "技能服务",
            5: "热门工作",
            6: "职位详情页",
            7: "消息页",
            8: "我",
            9: "个人中心",
            10: "下单页",
        },

    }
}


// WEBPACK FOOTER //
// ./src/datamap.js